import { Modal } from 'bootstrap';

// Po powrocie z PayU strona główna dostaje ?rejestracja=sukces|blad|karta|dane.
// `karta` = płatność się udała, ale karta nie spełnia warunków regulaminu §1.2
// (firmowa lub wydana poza Polską) — inny komunikat niż zwykły błąd płatności.
// `dane` = płatność przeszła poprawną kartą, ale inną niż zgłoszona w formularzu (BIN się nie zgadza) —
// to pomyłka użytkownika, więc mówimy mu wprost, co się rozjechało (patrz RegistrationController::status).
// Otwieramy odpowiedni modal podziękowań, obsługujemy jawnie zamknięcie
// (nie polegamy tylko na data-bs-dismiss) i czyścimy URL, żeby odświeżenie go nie powtarzało.
// `platnosc` to jedyny wpis, którego nic nie generuje w normalnym przepływie: modal
// niedostępności PayU otwiera handler formularza po odpowiedzi 503, a nie powrót z paywalla.
// Trzymamy go tu, żeby dało się pokazać treść klientowi tak samo jak pozostałe ekrany,
// bez czekania na realną awarię operatora — patrz form/handler/registration-error.js.
const MODALS = {
	sukces: 'registrationSuccessModal',
	blad: 'registrationErrorModal',
	karta: 'registrationCardModal',
	dane: 'registrationDataModal',
	platnosc: 'registrationPayuModal',
};

function wireCloseButtons(el, modal) {
	el.querySelectorAll('[data-modal-close]').forEach((btn) => {
		btn.addEventListener('click', (event) => {
			event.preventDefault();
			modal.hide();

			const scrollTargetId = btn.getAttribute('data-modal-scroll');
			if (scrollTargetId) {
				const target = document.getElementById(scrollTargetId);
				if (target) {
					target.scrollIntoView({ behavior: 'smooth' });
				}
			}
		});
	});
}

function openPaymentModal() {
	const params = new URLSearchParams(window.location.search);
	const result = params.get('rejestracja');
	const modalId = MODALS[result];
	if (!modalId) {
		return;
	}

	const el = document.getElementById(modalId);
	if (el) {
		const modal = Modal.getOrCreateInstance(el);
		wireCloseButtons(el, modal);
		modal.show();
	}

	// wyczyść parametr z adresu (bez przeładowania), zostaw ewentualną resztę query
	params.delete('rejestracja');
	const query = params.toString();
	window.history.replaceState({}, '', window.location.pathname + (query ? `?${query}` : ''));
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', openPaymentModal);
} else {
	openPaymentModal();
}
